import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { segmentApi } from '@edulastic/api'
import { IconPDLSparkle, IconArrowRight } from '@edulastic/icons'
import {
  StyledGenerateStandardsBannerWrapper,
  StyledGenerateStandardsBanner,
  StyledBannerBetaTag,
  StyledBannerRow,
  StyledBannerTextContainer,
  StyledBannerText,
  StyledBannerLink,
} from './styled'

const GenerateStandardsBanner = ({
  onGenerateClick,
  disabled,
  disabledTooltip,
  testId,
}) => {
  const handleGenerateClick = () => {
    segmentApi.genericEventTrack(
      'AITestQuestionsMetadata:GenerateStandardsBannerClick',
      { testId },
      { attachUserData: true }
    )
    onGenerateClick()
  }

  const generateButton = (
    <StyledBannerLink
      type="button"
      data-cy="generateStandardsButton"
      aria-label="Generate now with Pear Assist AI"
      disabled={disabled}
      onClick={disabled ? () => {} : handleGenerateClick}
    >
      GENERATE NOW
      <IconArrowRight
        width={18}
        height={18}
        color="#000000"
        margin="0 0 0 4px"
      />
    </StyledBannerLink>
  )

  return (
    <StyledGenerateStandardsBannerWrapper>
      <StyledBannerBetaTag data-cy="generateStandardsBannerBeta">
        BETA
      </StyledBannerBetaTag>
      <StyledGenerateStandardsBanner
        data-cy="generateStandardsBanner"
        data-joyride-id="testMetadataAssistanceBanner"
        disabled={disabled}
      >
        <StyledBannerRow>
          <IconPDLSparkle width={24} height={24} aria-hidden="true" />
          <StyledBannerTextContainer>
            <StyledBannerText>
              Use Pear Assist to review and add standards, DoK, difficulty, and
              rubrics to all your items.
            </StyledBannerText>
            {disabled ? (
              <Tooltip title={disabledTooltip}>
                <span>{generateButton}</span>
              </Tooltip>
            ) : (
              generateButton
            )}
          </StyledBannerTextContainer>
        </StyledBannerRow>
      </StyledGenerateStandardsBanner>
    </StyledGenerateStandardsBannerWrapper>
  )
}

GenerateStandardsBanner.propTypes = {
  onGenerateClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  testId: PropTypes.string,
}

GenerateStandardsBanner.defaultProps = {
  disabled: false,
  disabledTooltip: '',
  testId: '',
}

export default GenerateStandardsBanner
